function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Coordinate from '../geom/Coordinate';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
var Quadrant = /*#__PURE__*/function () {
  function Quadrant() {
    _classCallCheck(this, Quadrant);
    Quadrant.constructor_.apply(this, arguments);
  }
  return _createClass(Quadrant, [{
    key: "getClass",
    value: function getClass() {
      return Quadrant;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isNorthern",
    value: function isNorthern(quad) {
      return quad === Quadrant.NE || quad === Quadrant.NW;
    }
  }, {
    key: "isOpposite",
    value: function isOpposite(quad1, quad2) {
      if (quad1 === quad2) return false;
      var diff = (quad1 - quad2 + 4) % 4;
      if (diff === 2) return true;
      return false;
    }
  }, {
    key: "commonHalfPlane",
    value: function commonHalfPlane(quad1, quad2) {
      if (quad1 === quad2) return quad1;
      var diff = (quad1 - quad2 + 4) % 4;
      if (diff === 2) return -1;
      var min = quad1 < quad2 ? quad1 : quad2;
      var max = quad1 > quad2 ? quad1 : quad2;
      if (min === 0 && max === 3) return 3;
      return min;
    }
  }, {
    key: "isInHalfPlane",
    value: function isInHalfPlane(quad, halfPlane) {
      if (halfPlane === Quadrant.SE) {
        return quad === Quadrant.SE || quad === Quadrant.SW;
      }
      return quad === halfPlane || quad === halfPlane + 1;
    }
  }, {
    key: "quadrant",
    value: function quadrant() {
      if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        var dx = arguments[0];
        var dy = arguments[1];
        if (dx === 0.0 && dy === 0.0) throw new IllegalArgumentException('Cannot compute the quadrant for point ( ' + dx + ', ' + dy + ' )');
        if (dx >= 0.0) {
          if (dy >= 0.0) return Quadrant.NE;else return Quadrant.SE;
        } else {
          if (dy >= 0.0) return Quadrant.NW;else return Quadrant.SW;
        }
      } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Coordinate) {
        var p0 = arguments[0];
        var p1 = arguments[1];
        if (p1.x === p0.x && p1.y === p0.y) throw new IllegalArgumentException('Cannot compute the quadrant for two identical points ' + p0);
        if (p1.x >= p0.x) {
          if (p1.y >= p0.y) return Quadrant.NE;else return Quadrant.SE;
        } else {
          if (p1.y >= p0.y) return Quadrant.NW;else return Quadrant.SW;
        }
      }
    }
  }]);
}();
export { Quadrant as default };
Quadrant.constructor_ = function () {};
Quadrant.NE = 0;
Quadrant.NW = 1;
Quadrant.SW = 2;
Quadrant.SE = 3;